var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIncomingServerIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1808 12.5556H13.1897M11.9363 9.88889H14.0697C14.898 9.88889 15.3122 9.88889 15.6389 10.0242C16.0745 10.2046 16.4206 10.5507 16.601 10.9863C16.7363 11.313 16.7363 11.7272 16.7363 12.5556C16.7363 13.3839 16.7363 13.7981 16.601 14.1248C16.4206 14.5604 16.0745 14.9065 15.6389 15.0869C15.3122 15.2222 14.898 15.2222 14.0697 15.2222H3.403C2.57465 15.2222 2.16048 15.2222 1.83378 15.0869C1.39817 14.9065 1.05209 14.5604 0.871653 14.1248C0.736328 13.7981 0.736328 13.3839 0.736328 12.5556C0.736328 11.7272 0.736328 11.313 0.871653 10.9863C1.05209 10.5507 1.39817 10.2046 1.83378 10.0242C2.16048 9.88889 2.57465 9.88889 3.40299 9.88889H5.53633M8.73633 10.7778V1M8.73633 1L11.403 3.66667M8.73633 1L6.06966 3.66667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIncomingServerIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/incomingServerIcon.e117f595c0bf39c4e3b71fb1b0cd4218.svg";